<template>
    <div id="main-wrapper">
        <NavbarDark/>

        <div class="page-title">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12 col-md-12">
                        <h2 class="ipt-title">{{$t('Our Articles')}}</h2>
                        <span class="ipn-subtitle">{{$t('See Our Latest Articles & News')}}</span>
                    </div>
                </div>
            </div>
        </div>

        <section class="gray-simple">
            <div class="container">
                <div class="row justify-content-center g-4">
                    <div v-for="(item, index) in blogData" :key="index" class="col-xl-4 col-lg-4 col-md-6">
                        <div class="blog-wrap-grid h-100 shadow">
                            <div class="blog-thumb">
                                <router-link v-if="localizedBlogPath(item)"
                                :to="localizedBlogPath(item)"><img :src="item.image" class="img-fluid" alt="blog image" /></router-link>
                            </div>
                            <div class="blog-info">
                            </div>
                            <div class="blog-body">
                                <h4 class="bl-title"><router-link v-if="localizedBlogPath(item)"
                                :to="localizedBlogPath(item)">{{item.title}}</router-link></h4>
                                <p>{{ truncateText(item.short_description, 10) }}</p>
                                <router-link v-if="localizedBlogPath(item)"
                                :to="localizedBlogPath(item)" class="post-date label bg-seegreen text-light "><i class="ti ti-calendar px-1"></i>{{$t('Continue')}}</router-link>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="scroll-sentinel" class="text-center my-4">
                    <span v-if="loading">{{ $t('Downloading..') }}</span>
                </div>				
            </div>
        </section>

        <FooterTop :bg="'theme-bg'"/>

        <FooterDark/>

        <ScrollToTop/>
    </div>
</template>

<script setup>
import FooterDark from '@/components/footer/footer-dark.vue';
import FooterTop from '@/components/footer/footer-top.vue';
import NavbarDark from '@/components/navbar/navbar-dark.vue';
import ScrollToTop from '@/components/scroll-to-top.vue';
import { useI18n } from "vue-i18n";
import { ref, onUnmounted, onMounted, watch} from "vue";
import axios from "axios";
const localizedBlogPath = (item) => {
const currentSlug = item.slug?.[locale.value]

if (!currentSlug) return null  

return `/${locale.value}/blog-detail/${currentSlug}`
}
const { locale } = useI18n();
const blogData = ref([]);
const currentPage = ref(1);
const totalPages = ref(1);
const totalResults = ref(0);
const perPage = ref(0);
const from = ref(0);
const to = ref(0);
const loading = ref(false);
const observer = ref(null);

const fetchBlogs = async () => {
if (loading.value || currentPage.value > totalPages.value) return;

loading.value = true;
    try {
        const response = await axios.get(`/blogs?page=${currentPage.value}&lang=${locale.value}&sort=latest`);
        
        if (currentPage.value === 1) {
            blogData.value  = response.data.data;
        } else {
            blogData.value .push(...response.data.data);
        }

        totalResults.value = response.data.total;
        perPage.value = response.data.per_page;
        from.value = (currentPage.value - 1) * perPage.value + 1;
        to.value = Math.min(from.value + blogData.value.length - 1, totalResults.value);
        totalPages.value = response.data.last_page;
        currentPage.value++;

    } catch (error) {
        console.error("Error fetching blogs:", error);
    } finally {
        loading.value = false;
    }
};

const setupObserver = () => {
    observer.value = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && !loading.value) {
            fetchBlogs();
        }
    });

    const sentinel = document.getElementById('scroll-sentinel');
    if (sentinel) observer.value.observe(sentinel);
};
onMounted(() => {
fetchBlogs();
setupObserver();
});

onUnmounted(() => {
    if (observer.value) observer.value.disconnect();
});

const truncateText = (text, wordLimit) => {
if (!text) return "";
const words = text.split(" ");
return words.length > wordLimit ? words.slice(0, wordLimit).join(" ") + "..." : text;
};
watch(
  () => locale.value,
  async () => {
    currentPage.value = 1;
    totalPages.value = 1;
    blogData.value = [];

    await fetchBlogs();
  }
);

import { computed } from 'vue';
import { useHead } from '@vueuse/head'
import { useRoute } from 'vue-router'
const route = useRoute()
const baseUrl = 'https://ruqm.me'

const canonicalUrl = computed(() =>
  `${baseUrl}${route.path}`
)

const supportedLocales = ['en', 'ar']

const hreflangLinks = computed(() => {
  const pathWithoutLang = route.path.replace(/^\/(en|ar)/, '')

  return supportedLocales.map(lang => ({
    rel: 'alternate',
    hreflang: lang,
    href: `${baseUrl}/${lang}${pathWithoutLang}`
  }))
})
useHead(() => ({
  link: [
    { rel: 'canonical', href: canonicalUrl.value },
    ...hreflangLinks.value,
    {
      rel: 'alternate',
      hreflang: 'x-default',
      href: `${baseUrl}/en${route.path.replace(/^\/(en|ar)/, '')}`
    }
  ]
}))
</script>
